import { createContext } from 'react';
var storeContext = createContext();
export default storeContext;